import { Middleware } from '@reduxjs/toolkit';

import { getCookie, QaToolKitOptions } from '@cashier/cashier-common';
import {
  fetchCertainPaymentMethodFailure,
  fetchCertainPaymentMethodSuccess,
  onPaymentMethodReady,
  refetchCertainPaymentMethodSuccess,
  setPaymentFormStatus,
} from '@cashier/cashier-data-access';
import { FormStatuses } from '@cashier/cashier-model';
import { loadPreprocessorResources } from '@cashier/cashier-shared';

export const paymentMethodMiddleware: Middleware =
  (store) => (next) => (action) => {
    const result = next(action);

    if (action.type === fetchCertainPaymentMethodSuccess.toString()) {
      const isEnabledHostedField =
        getCookie(QaToolKitOptions.enableHostedField) === 'true';

      store.dispatch(onPaymentMethodReady());

      if (isEnabledHostedField) {
        store.dispatch(setPaymentFormStatus(FormStatuses.READY));
      } else {
        // TODO delete after testing 2914
        const {
          method: { preprocessor },
        } = action.payload;

        if (preprocessor) {
          loadPreprocessorResources(preprocessor)
            .then(() => {
              store.dispatch(setPaymentFormStatus(FormStatuses.READY));
            })
            .catch((error) => {
              store.dispatch(fetchCertainPaymentMethodFailure(error.message));
            });
        } else {
          store.dispatch(setPaymentFormStatus(FormStatuses.READY));
        }
      }
    }

    if (action.type === refetchCertainPaymentMethodSuccess.toString()) {
      store.dispatch(setPaymentFormStatus(FormStatuses.READY));
    }

    return result;
  };
